import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';

export const addTeamMembersTE = <E = CF.API.ApiError>(
  { orgId, teamId, body }: { orgId: string; teamId: string; body: { user_ids: string[] } },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Organizations.ListTeamMembersResponse> =>
  fetchTE<CF.API.Organizations.ListTeamMembersResponse, E>(
    {
      path: `/api/_api/v2/organizations/${orgId}/teams/${teamId}/users`,
      method: 'POST',
      body,
    },
    onRejected,
  );
